import { AppProvider } from "./provider";
import { AppRouter } from "./router";
import { PwaReloadPrompt } from "@shared/components/pwa/pwa-reload-prompt";
import { PwaInstallPrompt } from "@shared/components/pwa/pwa-install-prompt";
import "./styles.css";

function App() {
  return (
    <AppProvider>
      <PwaReloadPrompt />
      <PwaInstallPrompt />
      <AppRouter />
    </AppProvider>
  );
}

export default App;
